import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationInsightsService } from './application-insights.service';

/**
 * Injects W3C traceparent header for requests to azurewebsites.net so that
 * server-side telemetry can correlate with frontend events.
 */
@Injectable()
export class TraceparentInterceptor implements HttpInterceptor {
  private static readonly AZURE_DOMAINS = ['azurewebsites.net', 'azure-api.net', 'api.recoverytrac.com'];
  constructor(
    private applicationInsightsService: ApplicationInsightsService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (TraceparentInterceptor.AZURE_DOMAINS.some(domain => req.url.includes(domain))) {
      const traceCtx = this.applicationInsightsService.getTelemetryTrace();
      const traceId = traceCtx?.traceID;
      const spanId = traceCtx?.parentID ?? this.applicationInsightsService.generateSpanId();

      if (traceId && spanId) {
        const traceparentValue = `00-${traceId}-${spanId}-01`;
        req = req.clone({
          setHeaders: {
            traceparent: traceparentValue,
          },
        });
      }
    }
    return next.handle(req);
  }
}
